import React from 'react';
import { Table, Card, Tag, Button, Space, Row, Col, Statistic, Input, Select } from 'antd';
import { SendOutlined, PlusOutlined, MessageOutlined } from '@ant-design/icons';

const smsData = Array.from({ length: 10 }, (_, i) => ({
  key: String(i + 1),
  msisdn: `1381234${String(5678 + i).padStart(4, '0')}`,
  direction: i % 2 === 0 ? 'down' : 'up',
  content: i % 2 === 0 ? ['【CMP平台】您的流量套餐即将到期，请及时续费。', '【CMP平台】您的设备已成功激活，ICCID: 898603...'][i % 2] : '回复TD退订',
  time: `2026-03-13 ${String(8 + i).padStart(2, '0')}:${String(i * 6 % 60).padStart(2, '0')}:00`,
  status: ['success', 'failed', 'pending'][i % 3],
}));

const SmsManage: React.FC = () => (
  <div style={{ padding: 16 }}>
    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
      {[
        { title: '本月发送', value: 12480 },
        { title: '发送成功', value: 12102 },
        { title: '发送失败', value: 378 },
        { title: '上行短信', value: 860 },
      ].map((item, i) => (
        <Col span={6} key={i}>
          <Card bordered={false} style={{ borderRadius: 8 }}>
            <Statistic title={item.title} value={item.value} suffix="条" />
          </Card>
        </Col>
      ))}
    </Row>

    <Row gutter={16}>
      <Col span={16}>
        <Card
          title={<span><MessageOutlined /> 短信记录</span>}
          bordered={false}
          style={{ borderRadius: 8 }}
          extra={<Select defaultValue="all" style={{ width: 120 }} options={[{ value: 'all', label: '全部' }, { value: 'down', label: '下行' }, { value: 'up', label: '上行' }]} />}
        >
          <Table
            dataSource={smsData}
            size="small"
            pagination={{ pageSize: 8 }}
            columns={[
              { title: '手机号', dataIndex: 'msisdn', key: 'msisdn' },
              {
                title: '方向', dataIndex: 'direction', key: 'direction', width: 80,
                render: v => <Tag color={v === 'down' ? 'blue' : 'green'}>{v === 'down' ? '下行' : '上行'}</Tag>
              },
              { title: '内容', dataIndex: 'content', key: 'content', ellipsis: true },
              { title: '时间', dataIndex: 'time', key: 'time', width: 160 },
              {
                title: '状态', dataIndex: 'status', key: 'status', width: 80,
                render: (v: string) => (
                  <Tag color={v === 'success' ? 'success' : v === 'failed' ? 'error' : 'processing'}>
                    {v === 'success' ? '成功' : v === 'failed' ? '失败' : '发送中'}
                  </Tag>
                )
              },
            ]}
          />
        </Card>
      </Col>
      <Col span={8}>
        <Card title="发送短信" bordered={false} style={{ borderRadius: 8 }}>
          <div style={{ marginBottom: 12 }}>
            <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>目标手机号</div>
            <Input placeholder="输入手机号，多个用逗号分隔" />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>短信模板</div>
            <Select style={{ width: '100%' }} placeholder="选择模板" options={[
              { value: '1', label: '套餐到期提醒' },
              { value: '2', label: '激活成功通知' },
              { value: '3', label: '流量预警通知' },
            ]} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={{ marginBottom: 4, fontSize: 12, color: '#666' }}>短信内容</div>
            <Input.TextArea rows={4} placeholder="输入短信内容..." />
          </div>
          <Button type="primary" icon={<SendOutlined />} block>发送短信</Button>
        </Card>
      </Col>
    </Row>
  </div>
);

export default SmsManage;
